import { useEffect } from 'react';

export const useClickOutside = (
  ref: React.RefObject<HTMLElement | null>,
  onClickOutside: () => void,
) => {
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (!ref.current || ref.current.contains(event.target as Node)) {
        // Clicked inside the referenced element
        return;
      }

      if (
        event.target instanceof Element &&
        event.target.closest('[data-click-outside-ignore]')
      ) {
        // Clicked inside an element that should ignore outside clicks
        return;
      }

      onClickOutside();
    };

    // Delay attaching the listener to avoid catching the click event that opened the element
    // This ensures the opening click has finished propagating before we start listening, e.g. when
    // opening a modal from the slideout, which is rendered via a portal.
    const timeoutId = setTimeout(() => {
      document.addEventListener('click', handleClickOutside);
    }, 0);

    return () => {
      clearTimeout(timeoutId);
      document.removeEventListener('click', handleClickOutside);
    };
  }, [ref, onClickOutside]);
};
